import { AAGUID } from '@interticket/core';
import { ITicketTemplateFormats } from '../../interfaces/ticket-template/ticket-template-formats.interface';

export class TicketTemplateFormats implements ITicketTemplateFormats {

  readonly electronic: AAGUID;
  readonly pieces: AAGUID;
  readonly sheet: AAGUID;

  constructor(iTicketFormats: ITicketTemplateFormats) {
    this.electronic = iTicketFormats.electronic;
    this.pieces = iTicketFormats.pieces;
    this.sheet = iTicketFormats.sheet;
  }

}
